import React, {Component} from 'react';
import {Link} from 'react-router';
 import formatNumbers  from 'util/formatNumbers';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import moment from 'moment';
import classNames from 'classnames'
import FaClose from 'react-icons/lib/fa/close';
 import HistoryDataModal   from 'shared/HistoryDataModal'
import FaCheck from 'react-icons/lib/fa/check';
import config from  '../../../config';
import {dateFormatter, displayCustomDialog, historyDataFormatter, prepareSelectOptionsList,actionsFormatter, customFormatter, priceFormatter, getFieldByPathFormatter} from 'util/Utils';

import {UPDATE_ADMIN_PRODUCT, DELETE_ADMIN_PRODUCT,ADD_SELECTED_PRODUCTS,
REMOVE_SELECTED_PRODUCTS} from "actions/actionTypes";

import TableArrayToCheckboxFormatter from 'shared/table/TableArrayToCheckboxFormatter.js';
import TableArrayToMultiSelectFormatter from 'shared/table/TableArrayToMultiSelectFormatter';
import CustomTableHeaderCheckbox from 'shared/table/CustomTableHeaderCheckbox';


class InventoryProjectProductListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);

        this.state = {
             perPage: config.table.numberPerPage,
            currentRecord:{},
        };

    }

    componentWillReceiveProps(nextProps) {

        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })

        }
    }
    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = []

      
         if ( _.get(row,'PalletProductData.PalletProductStatus') == 'Checked' &&  _.includes(_.get(row, 'ShopifyProductID', '',), 'temporary') ){  /*&& (_.isUndefined(_.get(row, 'CustomData.AddVariationsRequestID')) || _.get(row, 'CustomData.MainVariation'))) {*/
            menuItemsMap.push({onClick: 'uncheckProduct', label: 'Un-check'})
        }

        menuItemsMap.push({onClick: 'deleteProduct', label: 'Delete record'})
        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }





    hideModal(){
        this.setState({currentRecord:{}, historyDataModalVisible:false});
    }

    deleteProduct(row) {
        console.log('in delete', this.props );
        if (_.get(row, 'CustomData.AddVariationsRequestID')){ /* reset all related products */
            this.setState({showDeleteProductVariation:true,currentRecord:row})
        } else {
            var methodData = {
                'type': 'delete',
                endpoint: '/products/' + encodeURIComponent(row._id),
                messageData: {'#1#': 'Product'},
                messageCode: 'recordDeleted',
                'success_event': DELETE_ADMIN_PRODUCT,
                'success_event_data': {'productID': row._id},
            };
            this.props.makeRequest({}, methodData);
        }
    }




    customLinkFormatter(cell, row) {
        return (
            <Link className=""
                  to={`/admin/product/${encodeURIComponent(row._id)}/edit`}>{`${row.ProductName}`}</Link>
        );
    }

    render() {
        var self = this;


        return (
            <div className="databases-table">
                <div className="bot10 purple font-size-20">{
                    _.get(_.find(config.inventoryProjectTypes,{value:_.get(this.props, 'InventoryProjectRecord.ProjectType')}), 'label')+' - '+
                moment(_.get(this.props, 'InventoryProjectRecord.StartDate')).format('MM/DD/YY') + ' - ' + _.get(this.props, 'InventoryProjectRecord.MarketName')
                }</div>
                <BootstrapTable data={this.props.adminProducts.data} ref='table'
                                 remote={ true }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                 } }
                 >
                    <TableHeaderColumn  width="100px" dataField="id" isKey={true}  hidden={true} autoValue={ true } hiddenOnInsert>Id</TableHeaderColumn>

                    <TableHeaderColumn width="120px" dataField='ProductName' dataAlign="center"  columnClassName={'break-word'} dataFormat={ this.customLinkFormatter }
                                       dataSort={true}>Title</TableHeaderColumn>
                    <TableHeaderColumn width="50px" dataField='InventoryProjectData.OriginalWarehouseLocation' dataAlign="center"
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                           // var foundProject = _.find(_.get(row, 'InventoryProjects',[]), function (item) {
                                           //     if (item.InventoryProjectID  == self.props.location.query.InventoryProjectID) {
                                           //         return true;
                                           //     }
                                           // })
                                           var styles = {position:'relative', top:2}
                                           if  (_.get(row, 'LocationInWarehouse') && _.get(row, 'LocationInWarehouse') !== _.get(row, 'InventoryProjectData.OriginalWarehouseLocation','n/a')){
                                               styles.color= 'red'
                                           }else  if (_.includes(['NotScanned','Confirmed' ],_.get(row, 'InventoryProjectData.ProductLocationStatus'))){
                                               styles.color= 'green'
                                           } else if (  _.includes(['Missing'],_.get(row, 'InventoryProjectData.ProductLocationStatus') )){
                                               styles.color= 'red'
                                           }
                                             return  <div style={styles}  >{_.get(row, 'InventoryProjectData.OriginalWarehouseLocation','')}</div>
                                       }}}   dataSort={true}>Location</TableHeaderColumn>
                    <TableHeaderColumn width="50px"   dataAlign="center"
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {path:[  'getObject']  , format: (row)=> {

                                           if (_.get(row, 'LocationInWarehouse') && _.get(row, 'LocationInWarehouse') !== _.get(row, 'InventoryProjectData.OriginalWarehouseLocation','n/a')){
                                               return  <div style={{color:'green'}}  >{_.get(row, 'LocationInWarehouse','')}</div>
                                           }
                                       }}}   >New Location</TableHeaderColumn>

                    <TableHeaderColumn width="70px" columnClassName={'break-word'}  tdStyle={ { whiteSpace: 'normal' } } thStyle={ { whiteSpace: 'normal' } } dataField='SellerAndPickupNumber'  dataAlign="center"  formatExtraData={ {path:['SellerAndPickupNumber']}}
                                       dataFormat={ getFieldByPathFormatter }   dataSort={true}>Vendor</TableHeaderColumn>

                    <TableHeaderColumn width="35px" dataField='Availability'     dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                         format: (row) => {

                             var styles ={ }
                             var Status = row.Status
                              if(Status == 'Inactive'){
                                 if(_.get(row, 'SaleTransactionReferences',[]).length >0){
                                     Status= 'Sold'
                                 } else{
                                     styles.color= 'red'
                                 }

                            }
                             return  <div   style={styles} >{Status}</div>


                        }
                    }} dataAlign="center"
                                       >Availability</TableHeaderColumn>
                    {_.includes(['SpotCheck','BiAnnual'],_.get(this.props, 'InventoryProjectRecord.ProjectType')) &&
                    <TableHeaderColumn width="35px"
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                                           format: (row) => {

                                                return <div>
                                                   {_.includes(['NotScanned','Confirmed' ],_.get(row, 'InventoryProjectData.ProductLocationStatus')) &&
                                                   <FaCheck className="green text-center"></FaCheck>
                                                   }
                                                   {_.includes(['Missing' ], _.get(row, 'InventoryProjectData.ProductLocationStatus')) &&
                                                   <FaClose style={{color: 'red'}} className=" text-center"></FaClose>
                                                   }
                                                   {_.get(row, 'InventoryProjectData.ProductLocationStatus') == 'NotScanned' &&
                                                   <div>
                                                       <div style={{}}>Not scanned</div>
                                                       <div
                                                           className="top4">{ _.get(row,   ['InventoryProjectData','CustomData', 'Notes'], '')}</div>

                                                   </div>
                                                   }
                                               </div>

                                           }
                                       }} dataAlign="center"
                    >Found</TableHeaderColumn>
                    }
                    {_.includes(['Monthly'],_.get(this.props, 'InventoryProjectRecord.ProjectType')) &&
                    <TableHeaderColumn width="35px" dataSort={true} dataField='CreatedInShopifyAt'
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                                           format: (row) => {
                                               var foundProject = _.find(_.get(row, 'InventoryProjects', []), function (item) {
                                                   if (item.InventoryProjectID == self.props.location.query.InventoryProjectID) {
                                                       return true;
                                                   }
                                               })
                                               console.log('foundProject', foundProject);
                                               return <div>
                                                   {foundProject.ProductLocationStatus == 'Confirmed' &&
                                                   <FaCheck className="green text-center"></FaCheck>
                                                   }
                                                   {_.includes(['Missing', 'NotScanned'], foundProject.ProductLocationStatus) &&
                                                   <FaCheck style={{color: 'red'}} className=" text-center"></FaCheck>
                                                   }
                                                   {foundProject.ProductLocationStatus == 'NotScanned' &&
                                                   <div>
                                                       <div style={{}}>Not scanned</div>
                                                       <div
                                                           className="top4">{_.get(foundProject, ['CustomData', 'Notes'], '')}</div>

                                                   </div>
                                                   }
                                               </div>

                                           }
                                       }} dataAlign="center"
                    >New Listing</TableHeaderColumn>
                    }

                    {/*<TableHeaderColumn width="30px" dataAlign="center"  columnClassName={'actions-column'}*/}
                                       {/*dataFormat={ this.customActionsFormatter.bind(this) }*/}
                {/*>Actions</TableHeaderColumn>*/}
                </BootstrapTable>

            </div>
        );

    }
}


export default InventoryProjectProductListTable;
